import React, { Fragment } from 'react';

// Components

import CheckLinkType from './utils/CheckLinkType';
import LanguageSwitch from './utils/LanguageSwitchContainer';
import LinkAndIcons from './utils/LinkAndIcons';
import LinkAsPopUp from './utils/LinkAsPopUp';
import ChatLink from './utils/ChatLink';
import Modal from './utils/Modal';
import RouterSymbol from './utils/IconsReactRouter';
import Symbol from './utils/Icons';
import Text from './utils/Text';
import { DropdownContainer } from './utils/DropdownContainer';
import Tooltip from '@components/common/tooltip/Tooltip';
import { buildTelToHref } from '@utils/normalize/buildTelToHref';

// Constants

import { HEADER_LINKS_TYPES } from './constants/headerLinkTypes';
import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '@constants/common/environmentLinkEndpointNames';


export const Links = ( props ) => {
    const {
        details: {
            name,
            className,
            visible
        },
    } = props;

    return (
        <Fragment>
            {  (visible === undefined ||  visible) &&
                <li className={className}>
                    <CheckLinkType key={name}
                        { ...{
                            ...props
                        } }
                    />

                </li>
            }

        </Fragment>
    );
};

const HeaderMenuLi = (props) => {
    const {
        children,
        details: { 
            className, 
            name, 
            path 
        },
        environment: { 
            links 
        },
        index,
    } = props;
    
    const isPhone = path === ENVIRONMENT_LINK_ENDPOINTS_NAMES.PHONE;
    const telHref = isPhone && links?.[path] ? buildTelToHref(links[path]) : null;

    const onClickHandler = () => {
        if (telHref) {
            window.location = telHref;
        }
    };

    const enhancedChildren = React.Children.map(children, (child) =>
        React.isValidElement(child) && isPhone
            ? React.cloneElement(child, { onClickHandler })
            : child
    );

    return (
        <li className={className} data-automation-id={`${name}_${index}`}>
            {enhancedChildren}
        </li>
    );
};

export const Dropdown = props => {
    const {
        details: { dropdown },
        replacements,
        environment,
        showModal,
        ssapForm,
    } = props;

    const iterateDropdown = (() => {
        return dropdown.map((subNavItem, index) => {
            const { name } = subNavItem;
            if (subNavItem.visible === undefined || subNavItem.visible(environment)) {
                return (
                    <TypeSwitch key={name}
                        {...{
                            details: subNavItem,
                            index,
                            name,
                            environment,
                            replacements,
                            showModal,
                            ssapForm,
                        }}
                    />
                );
            }
        });
    })();
    
    return <DropdownContainer {...props}>{iterateDropdown}</DropdownContainer>;
};

export const TypeSwitch = props => {

    const {
        details: {
            name,
            text,
            tooltip: {
                text: tooltipText,
                placement
            } = {},
            tooltipClassName,
            linkClassName,
            type
        },
        index,
        replacements,
        environment: {
            user,
            language,
            links,
        }
    } = props;

    const linkType = typeof type === 'function' ? type(props.environment) : type;

    switch(linkType) {
        case HEADER_LINKS_TYPES.LINK:
            return (
                <Fragment key={`${name}_${index}`}>
                    <Links { ...{ ...props, index } }/>
                </Fragment>
            );
        case HEADER_LINKS_TYPES.ICON:
            return (
                <Fragment key={`${name}_${index}`}>
                    <Symbol { ...{ ...props, index } }/>
                </Fragment>
            );
        case HEADER_LINKS_TYPES.ICON_REACT_ROUTER:
            return (
                <Fragment key={`${name}_${index}`}>
                    <RouterSymbol { ...{ ...props, index } }/>
                </Fragment>
            );
        case HEADER_LINKS_TYPES.LINKS_AND_ICONS:

            return (
                <Fragment key={`${name}_${index}`}>
                    <LinkAndIcons { ...{ ...props, index } }/>
                </Fragment>        
            );
        case HEADER_LINKS_TYPES.LANGUAGE_SWITCH:
            return (
                <Fragment key={`${name}_${index}`}>
                    <LanguageSwitch { ...{ ...props, index } }/>
                </Fragment>
            );
        case HEADER_LINKS_TYPES.LINK_AS_POPUP:
            return (
                <Fragment key={`${name}_${index}`}>
                    <LinkAsPopUp { ...{ ...props, index } }/>
                </Fragment>
            );
        case HEADER_LINKS_TYPES.DROPDOWN:
            return (
                <Fragment key={`${name}_${index}`}>
                    <Dropdown { ...{ ...props, index } }/>
                </Fragment>
            );
        case HEADER_LINKS_TYPES.TEXT:
            return (
                <Fragment key={`${name}_${index}`}>
                    <Text { ...{ ...props, index } }/>
                </Fragment>
            );
        case HEADER_LINKS_TYPES.TOOLTIP:
            return (
                <HeaderMenuLi { ...props }>
                    <Tooltip
                        { ...{
                            id: text,
                            content: tooltipText,
                            place: placement,
                            dataAutomationId: `${name}_tooltip`,
                            //index: 'find_local_assistance',
                            contentClassName: tooltipClassName,
                            triggerDecorationClassName: linkClassName,
                            replacement: replacements
                        } }
                    />
                </HeaderMenuLi>
            );
        case HEADER_LINKS_TYPES.MODAL:
            return (
                <Fragment key={`${name}_${index}`}>
                    <Modal { ...{ ...props, index } }/>
                </Fragment>
            );
        case HEADER_LINKS_TYPES.CHAT:
            return (
                <Fragment key={`${name}_${index}`}>
                    <ChatLink { ...{ ...props, index, user, language }}/>
                </Fragment>
            );        
        default:
            return null;
    }
};
